<template>
  <div :class="['coupon', invalidCoupon ? 'invalid' : '']">
    <div class="coupon-left">
      <div class="value">
        ￥<span>{{ coupon.couponValue }}</span>
      </div>
      <div class="msg">{{ coupon.thresholdMsg }}</div>
      <img
        v-if="canUse"
        class="statusimg"
        src="@/images/coupon_center/small_linqu.png"
      />
      <img
        v-if="outSale"
        class="statusimg"
        src="@/images/coupon_center/small_qiangguang.png"
      />
      <img
        v-if="hasUsed"
        class="statusimg"
        src="@/images/coupon_center/small_yishiyong.png"
      />
    </div>
    <div class="coupon-right" @click.stop="handleBtn">
      <p class="text">{{ couponText }}</p>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'
export default {
  name: 'ActivityCoupon',
  mixins: [mixin],
  props: {
    urlId: {
      type: String,
      default: ''
    },
    activityId: {
      type: String,
      default: ''
    }
  },
  methods: {
    receiveTracer() {
      this.$track(this.$trackMap.couponCenter.adCouponClick, {
        str_coupon_id: String(this.coupon.modelId) || '',
        activity_id: String(this.activityId) || '',
        cms_id: Number(this.urlId) || 0
      })
    },
    goUseTracer() {
      this.$track(this.$trackMap.couponCenter.adCouponClick, {
        str_coupon_id: String(this.coupon.modelId) || '',
        activity_id: String(this.activityId) || '',
        cms_id: Number(this.urlId) || 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon {
  width: 2.2rem;
  height: 1.12rem;
  margin-right: 0.22rem;

  background-image: url('../../../images/coupon_center/coupon_bg.png');
  background-size: 100% 100%;

  background-repeat: no-repeat;

  @include flex-row-center;

  &-left {
    position: relative;

    height: 100%;
    overflow: hidden;

    flex: 1;

    color: #ff5c00;

    @include flex-column-center;
    .statusimg {
      position: absolute;
      top: -0.24rem;
      right: -0.06rem;
      z-index: 1;

      width: 0.8rem;
      height: 0.8rem;
    }
    .value {
      position: relative;
      z-index: 2;

      font-size: 0.28rem;

      & > span {
        font-size: 0.48rem;
        font-weight: bold;
      }
    }
    .msg {
      width: 100%;

      font-size: 0.24rem;
      text-align: center;

      @include text-overflow-ellipsis-single;
    }
  }
  &-right {
    width: 0.72rem;
    height: 100%;

    flex: none;
    @include flex-row-center;
    .text {
      font-size: 0.24rem;
      font-weight: 500;
      letter-spacing: 2px;
      color: #ff5c00;

      writing-mode: vertical-lr;
    }
  }
  &.invalid {
    background-image: url('../../../images/coupon_center/coupon_bg_invalid.png');
    .coupon-left {
      color: #b3b3b3;
    }
    .coupon-right {
      .text {
        color: #b3b3b3;
      }
    }
  }
}
</style>
